"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    grid: {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    },
    figure: {
      margin: '0',
      padding: 0,
      display: 'block',
      textAlign: 'center',
      width: '100%'
    },
    iframe: {
      height: '45vh',
      width: '100%'
    },
    figcaption: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(0.5),
      fontSize: '0.733rem',
      fontStyle: 'italic'
    }
  };
});
var _default = useStyles;
exports["default"] = _default;